const palette = {
  white: '#ffffff',
  black: '#000000',

  blackCoral: '#596069',
  brightGray: '#eaeaee',
  celticBlue: '#1e60e3',
  cetaceanBlue: '#060e41',
  charcoal: '#373b54',
  independence: '#494d63',
  indigo: '#25365a',
  lavenderGray: '#c3c4cf',
  lightPeriwinkle: '#c2c6dc',
  lotion: '#fafafa',
  manatee: '#9ba0a5',
  onyx: '#353a3f',
  rhythm: '#727691',
  sapphire: '#184db6',
  venetianRed: '#d50f12',
  vistaBlue: '#78a0ee',
  yellowGreen: '#12b81a',

  // Legacy
  red: '#f00',

  bunting: '#171f48',
  deepCove: '#060e41',
  deepCoveAlpha: 'rgba(6, 14, 65, 0.02)',
  roseBud: '#f9b38e',
  linen: '#f9dfd7',
  softPeachAlt: '#faf6f6',
  softPeach: '#ebdede',
  waikawaGray: '#565e92',
  ziggurat: '#bdd3de',
  royalBlue: '#5c68e0',
  halfBaked: '#87c5d3',

  bonJour: '#e5dfe1',
  blackOpacity: 'rgba(0, 0, 0, 0.7)',
  whiteOpacityLight: 'rgba(255, 255, 255, 0.4)',
  clear: 'rgba(255, 255, 255, 0)',
  ghost: '#c1c3cf',
  silverChalice: '#adadad',
  border: '#394750',
  alto: '#d6d6d6',
  burntSienna: '#f05f52',
  cinnabar: '#e54a4a',

  actionBlue: '#1316cf',
  actionWhite: '#eeefff',
  lamantin: '#888b9f',
  cryola: '#f2f3f9',
  ghostWhite: '#fafaff',
  lavanda: '#f1f1fc',
  ghostWhiteAlt: '#f4f5ff',
  deepBlue: '#61647a',
  ultramarine: '#0510ad',
  signalBlackOpacity: 'rgba(28, 28, 28, 0.9)',
  almondLight: '#fcf7f7',
  pinkAmaranth: '#e2d0d2',
  pinkAmaranthLight: '#f5eeef',
  pinkAmaranthDark: '#d8c0c3',
  pinkAmaranthDull: '#ebdede',
  ultramarineBlue: '#1f2654',
  nightBlue: '#29305d',
  periwinkle: '#c9dcff',
  frost: '#b6cfff',
  signalBlack: '#313030',
  lightGold: '#fffa8a',
  pearlWhite: '#fcfaf9',
  spaceCadet: '#111a52',
}

export default palette
